ceregoCommon.factory('LibraryResource', ['$resource', ($resource) ->
  $resource APIRoutes.v2_my_smart_modules_path(), {},
    nextUp:
      method: 'GET',
      isArray: false,
      url: APIRoutes.next_up_v2_my_smart_modules_path()
])
